import AppShell from "../shared/AppShell";
import SettingsView from "../settings/SettingsView";

const Settings: React.FC = () => {
  return (
    <AppShell>
      <SettingsView />
    </AppShell>
  );
};

export default Settings;
